import { useState, useMemo } from 'react';
import { Pages } from '../Core/Enums';
import {
    Props as LoaderButtonProps,
} from '../Core/Components/Inputs/LoaderButton/LoaderButton';

import { Header } from '../Core/Components/Header/Header';
import { DatePicker } from '../Core/Components/MiniDatePicker/MiniDatePicker';

import { StoreOrderBookTable } from './StoreOrderBookTable/StoreOrderBookTable';
import { useStoreOrderBookTableData } from './StoreOrderBookTable/useStoreOrderBookTableData';
import { FooterContainer } from '../Core/Components/Footer/Footer';

import './StoreOrderBookPage.scss';
import { SlideInOverlay } from '../Core/Components/SlideInOverlay/SlideInOverlay';
import { StoreOrder } from '../Core/SharedTypes/Models';
import { PerformantPrintable } from '../Core/Components/PerformantPrintable/PerformantPrintable';
import { StoreOrderBookTableExpanded } from './StoreOrderBookTableExpanded/StoreOrderBookTableExpanded';

import { Lightswitch } from '../Core/Components/Lightswitch/Lightswitch';

export const StoreOrderBookPage = () => {
   // Get the data for the table
    const tableData = useStoreOrderBookTableData();

    // Get the state for the refresh button
    const refreshButtonState: LoaderButtonProps['state'] = useMemo(() => {
        return tableData.isFetching || tableData.isSaving ? 'loading' : 'idle';
    }, [tableData.isFetching, tableData.isSaving]);

    const [showLineitems, setShowLineitems] = useState(false);
    const handleLineitems = (newValue: boolean) => {
        setShowLineitems(!showLineitems); // Reset selected order for creation view
	};

    // State for the slide in overlay
    const [isOpen, setIsOpen] = useState(false);
    const handleSlideIn = () => {
        tableData.refresh(); // Refresh the table data
        setSelectedOrder(null); // Reset selected order for creation view
        setIsOpen(!isOpen);
	};

    // State for selected order
    const [selectedOrder, setSelectedOrder] = useState<StoreOrder | null>(null);
    const handleOrderClick = (order: StoreOrder) => {
        setSelectedOrder(order); // Set clicked order data
        setIsOpen(!isOpen);
    };

    return (
        <div className="store-order-page">
            <div className="store-order-page__header">
                <Header
                    page={Pages.ORDERBOOK_STORE_PAGE}
                    button={
                        <button className="new-order" onClick={() => handleSlideIn()}>
                            <span className="new-order__icon">+</span>
                            <span className='new-order__text'>Opret ny</span>
                        </button>
                    }
                >
                    <PerformantPrintable 
                        isLoading={tableData.isLoading}
                        baseClass="store-order-page"
                    />
                    <DatePicker />
                </Header>
            </div>

            <div className="store-order-page__content">
                <>
                    <div className='store-order-page__show-lineitems'>
                        <span>Vis ordrelinjer</span>
                        <Lightswitch 
                          value={showLineitems} 
                          onToggle={(newValue) => handleLineitems(newValue)}
                          text=''
                        />
                    </div>
                    {
                        !showLineitems ? (
                            <StoreOrderBookTable 
                                {...tableData} 
                                handleOrderClick={(order) => handleOrderClick(order)}
                            />
                        ) : (
                            <StoreOrderBookTableExpanded 
                                {...tableData} 
                                handleOrderClick={(order) => handleOrderClick(order)}
                            />                        
                        )
                    }
                </>
            </div>
            <div className="store-order-page__footer">
				<FooterContainer page={Pages.ORDERBOOK_STORE_PAGE} />
			</div>
            <SlideInOverlay
                orderData={selectedOrder}
                isOpen={isOpen}
                setIsOpen={() => handleSlideIn()}
            />
        </div>
    );
};